import { useEffect } from "react"
import { captureException } from "../services/exception-logger"

export const useLogNetworkLoss = () => {
  const logNetworkLoss = () => {
    captureException("Network error detected")
  }

  // Will fire when network is disconnected
  return useEffect(() => {
    window.addEventListener("offline", logNetworkLoss)

    return () => {
      window.removeEventListener("offline", logNetworkLoss)
    }
  }, [])
}
